import { FlexLayout } from '@deity/falcon-ui';
import type { FC } from 'react';
import type { IContainerChildrenProps } from 'utils/IContainerChildrenProps';

interface IContentContainerProps {
  justifyContent?: 'center' | 'start' | 'end' | 'flex-start' | 'flex-end' | 'left' | 'right';
}
export const ContentContainer: FC<IContentContainerProps & IContainerChildrenProps> = ({
  justifyContent = 'center',
  children
}) => (
  <FlexLayout
    pl="sm"
    pr="sm"
    css={{
      justifyContent,
      width: '100vw',
      '@media(min-width: 1630px)': {
        paddingRight: 0,
        paddingLeft: 0,
        width: '1600px'
      }
    }}
  >
    {children}
  </FlexLayout>
);
